/**
 * Friendly per-device label ("Desk", "iPad"). Lives in its own tiny, dependency-free
 * module so App can keep it synced from the persisted setting and the storage layer
 * can stamp it onto synced writes (Chapter.lastEditedDevice) WITHOUT either importing
 * the other. Empty string = unnamed (callers fall back to a generic label).
 */
export const deviceNameRef = { current: '' }
